import moment from 'moment';
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';
import Button from '../../atoms/Buttons';
import DateTimeRange from '../../atoms/DateTimeRange';
import Label from '../../atoms/Label';
import TextBox from '../../atoms/TextBox';

type Query = {
  sender_user_id: string | undefined;
  receiver_user_id: string | undefined;
  from: moment.Moment | null | undefined;
  to: moment.Moment | null | undefined;
};

type Props = {
  query: Query;
  setQuery: (query: Query) => void;
};

type FormFilterParams = {
  date_range: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
  sender_user_id: string | undefined;
  receiver_user_id: string | undefined;
};

const FilterFormWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  flex-direction: column;
`;

const FilterRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;

  ${Label}, ${DateTimeRange} {
    margin: 0;
  }
`;

const FilterForm = ({ query, setQuery }: Props) => {
  const formValues = {
    date_range: {
      from: query.from ?? null,
      to: query.to ?? null,
    },
    sender_user_id: query.sender_user_id ?? undefined,
    receiver_user_id: query.receiver_user_id ?? undefined,
  };

  const { handleSubmit, control, register, reset } = useForm<FormFilterParams>({
    defaultValues: formValues,
  });

  const onSubmit = (data: FormFilterParams) => {
    const { date_range, sender_user_id, receiver_user_id } = data;

    setQuery({ ...date_range, sender_user_id, receiver_user_id });
  };

  useEffect(() => {
    reset(formValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return (
    <FilterFormWrapper>
      <FilterRow>
        <Label>抽出期間</Label>
        <Controller
          name="date_range"
          control={control}
          render={({ field: { value, onChange } }) => (
            <DateTimeRange
              dateRange={{
                from: value.from,
                to: value.to,
              }}
              setDateRange={(range) => {
                if (!range?.from?.isSame(value?.from)) {
                  onChange({
                    from: range.from ?? null,
                    to:
                      range.from?.clone().add(3, 'months').subtract(1, 'day').endOf('day') ?? null,
                  });
                  return;
                }

                onChange({ from: range.from ?? null, to: range.to ?? null });
              }}
              dateTimeProps={{
                fromProps: { showIcon: true },
                toProps: {
                  showIcon: true,
                },
              }}
            />
          )}
        />
        <Label>送付元ID</Label>
        <TextBox {...register('sender_user_id')} />
        <Label>送付先ID</Label>
        <TextBox {...register('receiver_user_id')} />
      </FilterRow>
      <FilterRow>
        <Button onClick={handleSubmit(onSubmit)}>検索</Button>
      </FilterRow>
    </FilterFormWrapper>
  );
};

export default FilterForm;
